import { _, Backbone, Marionette, moment, Radio } from "../../../../vendor";
import { Biscuit, Notification, FormatHelper } from "../../../utils";
import InboomaBaseView from "../../InboomaBaseView";
import InboomaBaseCollectionView from "../../InboomaBaseCollectionView";

import Contingent from "../../../models/Contingent";

import ContingentsListTpl from "../../../templates/orders/ReservationForm/ContingentsListTpl.html";
import ContingentItemTpl from "../../../templates/orders/ReservationForm/ContingentsListItemTpl.html";
import "typeahead.js";

const harmonizeModel = (model) => {
  const pricetariffs = Radio.channel("pricetariffs").request("get:data");

  // Auto-select pricetariff
  if (typeof model.get("pricetariff_id") == "undefined") {
    if (typeof pricetariffs.models[0] !== "undefined") {
      model.set(
        {
          pricetariff_id: 36, // == 'Normaltarif' pricetariffs.models[0].get('id')
        },
        {
          silent: true,
        },
      );
    }
  }

  const vouchers = Radio.channel("vouchers").request("get:data");

  if (typeof model.get("price") !== "object") {
    model.attributes.price = {
      tariff_price:
        typeof model.get("tariff_price") !== "undefined" ? Number(model.get("tariff_price")) : "",
      price: typeof model.get("price") == "string" ? Number(model.get("price")) : "",
      info: typeof model.get("price_info") !== "undefined" ? model.get("price_info") : "",
    };

    delete model.attributes.tariff_price;
  }
};

/**
 * Fetch available numbers of contingent
 *
 * @param {Backbone.Model} reservation
 * @param {int} contingent_id
 * @param {function} callback
 */
export const GetContingentNumbersAvailable = (reservation, contingent_id, callback) => {
  const RequestHelper = Backbone.Model.extend({
    url: "/contingents/getAvailabilityForAll",
  });

  const requestHelper = new RequestHelper({
    begin: reservation.get("begin") + (reservation.get("begin").length < 19 ? ":00" : ""),
    end: reservation.get("end") + (reservation.get("end").length < 19 ? ":00" : ""),
    contingent_id: Number(contingent_id),
  });

  if (reservation.get("id") !== "" && reservation.get("id") !== null) {
    requestHelper.set("reservation_id", reservation.get("id"));
  }

  requestHelper.save(null, {
    success(model, data) {
      callback(data.data.contingents[0].available);
    },
    error() {
      console.log("ERROR in GetContingentNumbersAvailable");
    },
  });
};

export const GetProductsAvailable = (contingent_ids, callback) => {
  const RequestHelper = Backbone.Model.extend({
    url: "/products/getRelatedProducts/" + contingent_ids,
  });

  const requestHelper = new RequestHelper().fetch({
    success(model, response) {
      callback(response.related_products);
    },
    error() {
      console.log("ERROR in GetProductsAvailable");
    },
  });
};
/**
 * The attributes order_item_price_id and is_updated are required for
 * price login in backend. This refs #19740
 */
const ContingentItem = InboomaBaseView.extend({
  template: ContingentItemTpl,
  className: "row force-float inb-reservation-contingent-item",

  ui: {
    pricetariffSelect: ".r-contingent-pricetariff",
    voucherTypeSelect: ".r-contingent-voucher-type",
    voucherTypeahead: ".r-contingent-voucher",
    removeBtn: ".r-contingent-remove",
    cloneBtn: ".r-contingent-clone",
    addBtn: ".r-contingent-add",
    freePriceField: ".free-price-field",
    lock: ".r-contingent-lock",
  },

  events: {
    "click @ui.pricetariffSelect": "_changePricetariff",
    "change @ui.voucherTypeSelect": "_changeVoucherType",
    "click @ui.removeBtn": "_remove",
    "click @ui.cloneBtn": "_clone",
    "click @ui.addBtn": "_add",
    "keyup @ui.freePriceField": "_keyupFreePriceField",
    "typeahead:select @ui.voucherTypeahead": "_inputVoucherTypeahead",
    //'input @ui.voucherTypeahead' : '_inputVoucherTypeahead',
    "focusout @ui.voucherTypeahead": "_inputVoucherTypeahead",
    "focusout @ui.freePriceField": "_focusoutFreePriceField",
    "click @ui.lock": "_toggleLock",
  },

  modelEvents: {
    "change:pricetariff_id": "_updateReservationPrice",
    "change:manual_override": "_updateReservationPrice",
    "change:price": "render",
    "change:voucher_type_id": "render", // Not really necessary...
  },

  templateContext() {
    let pricetariffs = Radio.channel("pricetariffs").request("get:data");
    let voucherTypes = Radio.channel("voucherTypes").request("get:data");

    voucherTypes = _.filter(voucherTypes.models, (model) => model.get("status"));
    voucherTypes = _.sortBy(voucherTypes, (model) => model.get("name").toLowerCase());

    harmonizeModel(this.model);

    let standard = false;

    if (typeof this.model.get("pricetariffs") !== "undefined") {
      pricetariffs = this.model.get("pricetariffs");
      standard = true;
    }

    let voucher_type_id = this.model.get("voucher_type_id") || null;
    let voucher_code = this.model.get("voucher_code") || null;

    /**
     * If voucher voucherType is not selected, we allow choose from all codes
     */
    this.filteredVouchers = voucher_type_id
      ? this.vouchers.models.filter((item) => item.get("voucher_type_id") === voucher_type_id)
      : this.vouchers.models;

    let maxUnits = this.options.parentView._baseContingent.get("max_available");
    let selectedUnits = this.options.parentView.collection.models.length;
    // collectionModelsLength >= this._baseContingent.get('max_available')) {
    // this.collection.models.length;

    return {
      _,
      moment,
      pricetariffs,
      standard,
      voucherTypes,
      voucher_type_id,
      voucher_code,
      currency: Biscuit.getClientCurrency(),
      formatPrice: (price) => Number(price).toLocaleString("de-DE", { minimumFractionDigits: 2 }),
      maxUnits,
      selectedUnits,
    };
  },

  _toggleLock() {
    this.model.set("is_updated", true);
    this.model.set("manual_override", !this.model.get("manual_override"));
  },

  _changePricetariff() {
    const pricetariff_id = Number(this.getUI("pricetariffSelect").val());
    this.model.attributes.price.price = "";

    if (typeof pricetariff_id !== "undefined") {
      this.model.set("pricetariff_id", pricetariff_id);
      this.model.set("is_updated", true);
    }
  },

  _changeVoucherType() {
    const val = this.getUI("voucherTypeSelect").val(),
      voucher_type_id = Number(val) || null,
      prevValue = this.model.get("voucher_type_id");

    this.model.set("voucher_type_id", voucher_type_id);
    this.model.set("voucher_code", "");
    this.model.set("is_updated", true);

    if (prevValue) {
      this.options.reservationView.getPrice();
    }
  },

  _inputVoucherTypeahead(event) {
    let rawCodeValue = this.getUI("voucherTypeahead").val();
    let voucherIdOld = this.model.get("voucher_id");

    this.model.set("voucher_code", rawCodeValue);

    let matchVoucher = _.find(this.filteredVouchers, (item) =>
      rawCodeValue.startsWith(item.get("voucher_code")),
    );

    if (matchVoucher) {
      this.model.set("voucher_id", matchVoucher.get("id"));

      if (!this.model.get("voucher_type_id")) {
        this.model.set("voucher_type_id", matchVoucher.get("voucher_type_id"));
      }
    } else {
      this.model.set("voucher_id", undefined);
    }

    // if (voucherIdOld !== this.model.get('voucher_id')) {
    this.options.reservationView.getPrice();
    //  }
  },

  // Prevents user from typing invalid characters
  _keyupFreePriceField(ev) {
    let val = ev.currentTarget.value;

    if (isNaN(val)) {
      val = val.replace(/[^0-9\,]/g, "");
      if (val.split(",").length > 2) {
        val = val.replace(/\,+$/, "");
      }
    }

    this.getUI("freePriceField").val(val);
  },

  _focusoutFreePriceField(ev) {
    let val = ev.currentTarget.value,
      apiFormattedPrice = Number(val.replace(",", "."));

    if (this.model.attributes.price.price == apiFormattedPrice) {
      // No action done by user
      return;
    }

    if (String(val).indexOf(",") < 0) {
      val += ",00";
      this.getUI("freePriceField").val(val);
    }

    this.model.attributes.price.price = apiFormattedPrice;
    this.model.attributes.is_updated = true;
    this.model.attributes.manual_override = true;

    this.model.trigger("change:pricetariff_id"); // Re-calculate total reservation price
  },

  _remove(ev) {
    ev.preventDefault();

    if (confirm(this.t("really_remove"))) {
      // Do not call directly this.model.destroy()
      // as this would trigger an API-request with DELETE method

      if (typeof this.model !== "undefined") {
        this.model.collection.remove(this.model);
        this.options.parentView.collection.remove(this.model);
        this.destroy();
        this.options.checkForEmptyCollection();
        this.options.reservationView.onChangeObserver.call(this.options.reservationView);
        this.options.reservationView.getPrice();
      }
    }
  },

  _clone(ev) {
    ev.preventDefault();
    this.options.parentView.cloneRow(this.model);
  },

  _add(ev) {
    this.options.parentView._addContingentUnit();
  },

  _updateReservationPrice() {
    this.render();
    this.options.reservationView.getPrice();
  },

  onRender() {
    const that = this;

    let codes = this.filteredVouchers.map((voucher) => voucher.get("voucher_code"));

    let substringMatcher = (strs) => {
      return (q, cb) => {
        let matches, substringRegex;

        // an array that will be populated with substring matches
        matches = [];

        // regex used to determine if a string contains the substring `q`
        let substrRegex = new RegExp(q, "i");

        // iterate through the pool of strings and for any string that
        // contains the substring `q`, add it to the `matches` array
        _.each(strs, (str, i) => {
          if (substrRegex.test(str)) {
            matches.push(str);
          }
        });

        cb(matches);
      };
    };

    if (codes.length) {
      this.getUI("voucherTypeahead")
        .typeahead("destroy")
        .typeahead(
          {
            minLength: 0,
            highlight: true,
          },
          {
            name: "vouchers",
            limit: 10,
            source: substringMatcher(codes),
          },
        );
    } else {
      this.getUI("voucherTypeahead").prop("disabled", true);
    }
  },

  initialize() {
    this.vouchers = Radio.channel("vouchers").request("get:data").proxy;
    this.filteredVouchers = this.vouchers.models;

    this.on("render", this.onRender); // ????
    // this.onRender();!!!
  },
});

export default InboomaBaseCollectionView.extend({
  childView: ContingentItem,
  template: ContingentsListTpl,
  childViewContainer: ".contingents-list",

  childViewOptions() {
    const that = this;

    return {
      locations: this._locations,
      reservationView: this.options.reservationView,
      checkForEmptyCollection() {
        that._toggleAddContingentUnit(true);
      },
      parentView: this,
    };
  },

  collectionEvents: {
    add(model) {
      harmonizeModel(model);
      this.options.reservationView.getPrice();
      this.options.reservationView.onChangeObserver.call(this.options.reservationView);

      this._toggleAddContingentUnit();
    },
  },

  templateContext() {
    return {
      baseContingent: this._baseContingent,
      originalSelectedUnits: this.options.originalSelectedUnits[this.contingentId],
      selectedUnits: this.collection.models.length, // only considered on intial call
      t: this.t,
    };
  },

  initialize() {
    Marionette.CollectionView.prototype.initialize.apply(this);

    // The first model in collection always carries the actual
    // contingent ID. Let's append it to all other models in scope!
    const that = this,
      inputModel = this.collection.models[0],
      allInputModels = this.collection.models;

    this._reservationEditMode = this.options.reservationView.model.get("id") !== "";

    this.contingentId = inputModel.get("id");
    inputModel.set("baseContingentId", this.contingentId);

    const hasSchoolBonus = _.some(inputModel.get("tags"), (tag) =>
      typeof tag.slug !== "undefined" ? tag.slug == "school_bonus" : tag == "school_bonus",
    );

    // Set default contingent state
    this._baseContingent = new Contingent({
      name: inputModel.get("name"),
      baseContingentId: inputModel.get("baseContingentId"),
      resourcetype_id: inputModel.get("resourcetype_id"),
      description: "", // inputModel.get('description') -> { de_DE : ..., en_GB : ... }
      tags: FormatHelper.formatContingentTags(inputModel.get("tags")),
      rab_parent_id: inputModel.get("rab_parent_id"),
      pricetariff_id: 36, // default = "Normalpreis",
      pricetariffs: inputModel.get("pricetariffs"),
      max_available: 1,
      manual_override: false,
      hasSchoolBonus,
    });
    // @todo if unknown...
    GetContingentNumbersAvailable(
      this.options.reservationView.model,
      inputModel.get("baseContingentId"),
      (amount) => {
        if (isNaN(amount)) {
          // Contingent is not available
          amount = 0;
        }

        that._baseContingent.set("max_available", amount);
        that.render();
      },
    );

    this.render();
  },

  onRender() {
    const that = this;

    this._toggleAddContingentUnit();

    let callGetPrice = false;

    _.each(this.collection.models, function (model) {
      if (model.attributes.price.price === "") {
        callGetPrice = true;
      }
    });

    if (callGetPrice) {
      window.setTimeout(function () {
        // This way we save some redundant calls on /getPrice
        that.options.reservationView.getPrice();
      }, 1500);
    }
  },

  _toggleAddContingentUnit(isDeleteEvent = false) {
    const collectionModelsLength = this.collection.models.length;

    if (collectionModelsLength === 0) {
      this.collection.models = [];
      this.destroy();
      return;
    } else if (collectionModelsLength >= this._baseContingent.get("max_available")) {
      var addBtns = document.getElementsByClassName("r-contingent-add"); // hide buttons immediately is necessary to avoid
      for (var i = 0; i < addBtns.length; i++) {
        // accidently adding more units than available
        this.$(addBtns[i]).addClass("hide");
      }
    }

    this.$el.find(".contingent-selected-units").html(collectionModelsLength);
  },

  _addContingentUnit() {
    // Clone and unset id to be actually added
    const clone = _.clone(this._baseContingent.toJSON());

    delete clone.id;

    const model = this.collection.add(clone);

    this._toggleAddContingentUnit();
  },

  /**
   * @method injectPricesIntoChildrenViews
   *
   * Usually called by ReservationsList.getPrice
   * Looks for any updatable prices and injects the new price
   *
   * @param {Object} prices As returned by API
   * @param {bool} forceReset Should prices be overwritten no matter what?
   */
  injectPricesIntoChildrenViews(prices, offset = 0) {
    const that = this;

    let hasInvalidVoucher = false;

    const setPricetariff = function (pricetariffPrice, ptId) {
      const model = that.collection.models[Number(pricetariffPrice.pos) - offset];

      if (typeof model == "undefined") return;

      if (typeof pricetariffPrice.voucher_error !== "undefined") {
        hasInvalidVoucher = true;
        model.attributes.voucher_code = null;
        model.attributes.voucher_id = null;
        model.attributes.voucher_type_id = null;
        model.attributes.voucher_error = pricetariffPrice.voucher_error;
      }
      if (
        typeof pricetariffPrice.manual_override !== "undefined" &&
        pricetariffPrice.manual_override
      ) {
        model.attributes.voucher_code = null;
        model.attributes.voucher_id = null;
        model.attributes.voucher_type_id = null;
      }

      if (Number(ptId) === 37) {
        // pricetariff "juniorcard" selected; but is it really valid?
        if (pricetariffPrice.juniorcard === "0.00" && pricetariffPrice.price !== 0) {
          // Switch back to "Normalpreis"
          model.attributes.pricetariff_id = 36;
        }
      }

      model.attributes.price = {
        tariff_price: Number(pricetariffPrice.tariff_price),
        info: pricetariffPrice.info,
        price: Number(pricetariffPrice.Complete),
        meta: {
          famigros: Number(pricetariffPrice.famigros),
          ab: Number(pricetariffPrice.ab),
          halftax: Number(pricetariffPrice.halftax),
          juniorcard: Number(pricetariffPrice.juniorcard),
        },
      };

      // Re-render...
      model.trigger("change:price");
      // call onChangeObserver to ensure it is called after price changes
      that.options.reservationView.onChangeObserver.call(
        that.options.reservationView,
        that.injectPricesIntoChildrenViews,
      );
    };

    _.each(prices, function (pricetariffs, cId) {
      if (Number(cId) !== that.contingentId) return;

      _.each(pricetariffs, function (pricetariffPrices, ptId) {
        if (ptId === "Complete") {
          return;
        }

        if (ptId === "no_price" && pricetariffPrices) {
          // Wrong tariff selected or no price available
          _.each(that.collection.models, (model) => {
            model.attributes.price.info = that.t("no_price_warning");
            model.trigger("change:price");
          });

          return;
        }

        if (typeof pricetariffPrices.length !== "undefined") {
          // = multiple contingentprices

          _.each(pricetariffPrices, function (pricetariffPrice) {
            setPricetariff(pricetariffPrice, ptId);
          });
        } else {
          // Only one contingentprice
          setPricetariff(pricetariffPrices, ptId);
        }
      });
    });

    if (hasInvalidVoucher) {
      new Notification({
        message: this.t("found_invalid_voucher"),
        duration: 5000,
        closeable: true,
        icon: "fi fi-x",
      });
    }
  },

  /**
   * Copying the values of the selected unit-row to the remaining rows
   * aka Row Cloning
   * @param model
   */
  cloneRow(model) {
    let targetId = this.parseItemCID(model.cid);

    _.each(this.collection.models, (modelItem) => {
      // skip selected and and those above rows
      if (this.parseItemCID(modelItem.cid) <= targetId) {
        return;
      }

      modelItem.set({
        price: model.get("price"),
        pricetariff_id: model.get("pricetariff_id"),
        voucher_code: model.get("voucher_code"),
        voucher_type_id: model.get("voucher_type_id"),
        voucher_id: model.get("voucher_id"),
        is_updated: true,
        manual_override: model.get("manual_override"),
      });

      modelItem.trigger("change:pricetariff_id");
    });
  },

  /**
   * Get integer value from cid for comparison.
   *
   * @param str
   * @returns {Number}
   */
  parseItemCID(str) {
    let match = str.match(/[a-z]*(\d+)/);

    return parseInt(match[1]);
  },
});
